<template>
    <div>
        <p class="text-center"><strong>Totalização</strong></p>
        <div class="reponsive-table">
            <table>
                <thead>
                    <th align="right">Saldo Anterior</th>
                    <th align="right" width="95">Débito</th>
                    <th align="right" width="95">Crédito</th>
                    <th align="right" width="95">Saldo Atual</th>
                </thead>
                <tbody>
                    <tr>
                        <td align="right" v-raw :class="totalizacao.ValorAnterior < 0 ? 'text-red' : 'text-green'">{{ totalizacao.ValorAnterior | number_format }}</td>
                        
                        <td v-if="totalizacao.ValorDebito != 0" align="right" v-raw class="text-red">{{ -totalizacao.ValorDebito | number_format }}</td>
                        <td v-else></td>

                        <td v-if="totalizacao.ValorCredito != 0" align="right" v-raw class="text-green">{{ totalizacao.ValorCredito | number_format }}</td>
                        <td v-else></td>
                        
                        <td align="right" v-raw :class="totalizacao.ValorAtual < 0 ? 'text-red':'text-green'">{{ totalizacao.ValorAtual | number_format }}</td>
                    </tr>
                </tbody>
            </table>
        </div>
    </div>
</template>
<script>
export default {
    props: ["totalizacao", 'filtro_lancamentos'],
    filters: {
        number_format(value) {
            let sign = '';
            if (value < 0) {
                sign = '<b class="number-sign">-</b>'
            }
            let str = sign + new Intl.NumberFormat("pt-BR", {
                currencySign: 'accounting',
                //currencySign: 'standard',
                style: "decimal",
                currency: 'BRL',
                minimumFractionDigits: 2,
                maximumFractionDigits: 2,
            }).format(Math.abs(value));

            return str;
        },
    },
};
</script>